<template>
  <div class="cdc">
    <div class="container">
      <div class="cdc__progress-bar-container">
        <ProgressBar :progress="progressAmount" />
      </div>
      <QuestionTitle :title="title" :subtitle="subtitle" />
      <div class="cdc__subcontainer">
        <div class="contact-form">
          <CDCForm :message="message" :call-now-text="callNowText" :button-icon="buttonIcon" class="cdc-form" />
        </div>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div class="chat-form-disclaimer" v-html="chatPageDisclaimer" />
      <!-- eslint-enable vue/no-v-html -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import QuestionTitle from '../components/question/QuestionTitle'
import CDCForm from '@mic/frontend/forms/CDCForm'
import IsOfficeOpen from '@mic/frontend/mixins/IsOfficeOpen'
import ProgressBar from '../components/progress/ProgressBar'

const whitelabel = require('../../whitelabel.config')

export default {
  name: 'ContactDetailsCapture',
  components: {
    QuestionTitle,
    CDCForm,
    ProgressBar
  },
  mixins: [IsOfficeOpen],
  data () {
    return {
      title: whitelabel[process.env.VUE_APP_BRAND].cdcTitle,
      subtitle: whitelabel[process.env.VUE_APP_BRAND].cdcSubtitle,
      callNowText: whitelabel[process.env.VUE_APP_BRAND].callNowText,
      buttonIcon: whitelabel[process.env.VUE_APP_BRAND].buttonIcon,
      chatPageDisclaimer:
        whitelabel[process.env.VUE_APP_BRAND].chatPageDisclaimer,
      lockIcon: require('@/assets/icons/blue-lock.svg'),
      message: { id: 'call-form' },
      progressAmount: 0.8
    }
  },
  computed: {
    ...mapGetters(['getAnswerById']),

    features () {
      return this.getAnswerById('qid_voip_features').result.map(
        (item) => item.label
      )
    },
    featuresText () {
      if (this.features.includes('Other/No preference')) return 'We will discuss and tailor a solution to suit your needs'
      if (this.features.length > 1) {
        const featureList = [...this.features]
        const lastItem = featureList.pop()
        return featureList.join(', ') + ' and ' + lastItem + ' are important'
      } else {
        return this.features[0] + ' is important'
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.progressAmount = 1
    }, 100)
  }
}
</script>

<style lang="scss">
.cdc {
  padding-top: $spacing-64;
  overflow: visible;
  background-color: $question-background;
  min-height: 100%;
  position: relative;
  display: flex;
  flex-grow: 1;

   @media (max-width: 719px) {
    padding-top: 24px;
  }

  /* remove google auto blue fill colour*/
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active{
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

  @media (min-width: $screen-md) {
    margin-bottom: 16px;
  }

  &__progress-bar-container {
      margin: 26px auto 16px auto;
      height: 13px;
      position: relative;
      width: 288px;
      top: 0;
      overflow: visible;
      background-color: #fff;
      border-radius: $border-radius-large;

    @media (min-width: 720px) {
      height: 16px;
      margin: 33px auto 40px auto;
      width: 472px;
    }
  }

  .progress-fill {
    width: 50%;
    position: absolute;
    left: 0;
    height: 100%;
    background-color: $progress-bar-fill;
    transition: width 0.6s;
    border-radius: $border-radius-large;
  }

  .title {
    text-align: left;

    @media(min-width: 720px) {
      text-align: center;
      margin-bottom: $spacing-32;
      margin-top: $spacing-40;
      max-width: 460px;
    }
  }

  &-input__label {
    font-size: 14px;
  }

  @media (min-width: $screen-md) {
    display: block;
  }

  &__subcontainer {
    max-width: 300px;
    margin: 0 auto;

     @media (min-width: 420px) {
        max-width: 340px;
     }

    @media (min-width: 720px) {
      display: flex;
      justify-content: center;
      max-width: 460px;
    }
  }

  .chat-form-disclaimer {
    color: $bionic-lightgrey;
    font-size: 12px;
    line-height: 18px;
    margin: 18px auto 46px;
    max-width: 306px;

    @media (min-width: 720px) {
      max-width: 990px;
    }

  }

  &__form {
    &--disclaimer {
      display: flex;
      font-size: 12px;
    }

    &--title {
      color: $h1-font-colour;
      font-size: 16px;
      font-weight: normal;

      @media (min-width: 800px) {
        font-size: 20px;
      }
    }
  }

  .subtitle {
    margin-top: 13px;
    margin-bottom: 15px;
    line-height: 19px;
    text-align: left;

    @media (min-width: 720px) {
      text-align: center;
      max-width: 460px;
    }
  }

  .contact-form {
    padding: $spacing-16;
    background: $white;
    border-radius: 6px;
    margin-top: 5px;
    box-shadow: 0 2px 11px 0 rgba(30,45,114,0.1);

    @media (min-width: 720px) {
      padding: $spacing-24 $spacing-40;
    }

    .submit-btn {
      width: 100%;
      max-width: unset;
      &:disabled {
        opacity: 0.3;
        color: rgba(255, 255, 255,  0.42%);

        img {
          display: none;
        }
      }
    }

    .form-input {
      margin-bottom: 15px;
    }

    .mic-input__input-container--error {
      .mic-input__input {
        border: 1px solid #D4251C;

        @media (min-width: 800px) {
          margin-bottom: 7px;
        }
      }
    }

    .mic-input {
      &__label {
        font-size: 14px;

         @media (min-width: 720px) {
          font-size: 16px;
          }
        }

      &__error {
        font-size: 12px;

      @media (min-width: 800px) {
        font-size: 14px;
       }

      }

      &__input {
        height: 56px;
        border: 1px solid #E5E5E5;
        padding: 20px 16px;
        border-radius: 6px;

        &-container {
          padding: 0;
          border: unset;
          img {
            display:none;
          }
        }

        &:focus {
          border: 1px solid #1370ff;
        }

         &::placeholder {
                   font-size: 14px;
         }
       }

      @media (min-width: 800px) {
        &__input {
          font-size: 14px;
        }
      }
    }

    .select-field,
    .select-field--time {
      select {
        padding: 0 0 0 16px;
        font-size: 13px;
      }
    }

    .phone-disclaimer-text {
        font-size: 10px;
       @media (min-width: 720px) {
        font-size: 14px;
       }

    }

    .cdc__form--disclaimer {
      align-items: baseline;
    }

    .disclaimer-text {
      &--mobile {
        display: block;

        @media(min-width: 800px) {
          display: none;
        }
      }

      &--desktop {
        display: none;
        @media(min-width: 800px) {
          display: block;
        }
      }
    }

    .lock {
      margin-right: 7px;
      margin-bottom: 25px;
    }

    .question-title {
      margin-top: 8px;
      margin-bottom: 20px;
    }
  }
}
</style>
